// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}


.Website-title {
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  color: rgb(195, 155, 34);
  font-size: 18px;
  font-weight: 600;
}


.management-tile {
  text-decoration: none;
  font-family: 'Montserrat', sans-serif!important;
  font-size: 20px !important;
  color: #000;
  font-size: 18px;
  font-weight: 600;
}

.typography-box {
  background-color: #f5f7fa;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px!important;
  color: #111827;
  box-shadow: none;
  font-family: 'Montserrat', sans-serif!important;
}


.form-label {
  color: #000;
  text-decoration: none;
  font-family: 'Montserrat', sans-serif!important;
  font-size: 14px!important;
  font-weight: 600!important;
}

.forgetpass {
  color: #C39B22;
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

.MuiFormControl-root {
  background-color: #f5f7fa;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  color: #111827;
  box-shadow: none;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  height: 35px;
}


/* .BoxCard {
  border: 1px solid rgb(229, 229, 229);
  border-radius: 8px;
  padding: 20px;
  position: relative;
} */

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,qNAAqN;AACvN;;;AAGA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,+CAA+C;AACjD;;;AAGA;EACE,WAAW;EACX,qBAAqB;EACrB,+CAA+C;EAC/C,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,YAAY;AACd;;;AAGA;;;;;GAKG","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n\n\n.Website-title {\n  text-decoration: none;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 18px;\n  color: rgb(195, 155, 34);\n  font-size: 18px;\n  font-weight: 600;\n}\n\n\n.management-tile {\n  text-decoration: none;\n  font-family: 'Montserrat', sans-serif!important;\n  font-size: 20px !important;\n  color: #000;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.typography-box {\n  background-color: #f5f7fa;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 13px!important;\n  color: #111827;\n  box-shadow: none;\n  font-family: 'Montserrat', sans-serif!important;\n}\n\n\n.form-label {\n  color: #000;\n  text-decoration: none;\n  font-family: 'Montserrat', sans-serif!important;\n  font-size: 14px!important;\n  font-weight: 600!important;\n}\n\n.forgetpass {\n  color: #C39B22;\n  text-decoration: none;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.MuiFormControl-root {\n  background-color: #f5f7fa;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 14px;\n  color: #111827;\n  box-shadow: none;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 14px;\n  height: 35px;\n}\n\n\n/* .BoxCard {\n  border: 1px solid rgb(229, 229, 229);\n  border-radius: 8px;\n  padding: 20px;\n  position: relative;\n} */\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
